import { render } from "./_InstrutorPdf.vue?vue&type=template&id=61b3633f&scoped=true"
import script from "./_InstrutorPdf.vue?vue&type=script&lang=ts"
export * from "./_InstrutorPdf.vue?vue&type=script&lang=ts"

import "./_InstrutorPdf.vue?vue&type=style&index=0&id=61b3633f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61b3633f"

export default script